import React from "react";
import "./Footer.css";
const Footer = () => {
    return (
        <div className="footer">
            <p>₢ Lucas Silveira 2023 | Todos os Direitos Reservados</p>
        </div>
    );
};

export default Footer;
